/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAMoveIcon20Solid = forwardRef('UiCursorAMoveIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.275 3.123c0-.483.392-.875.875-.875h7.1a.875.875 0 0 1 0 1.75h-7.1a.875.875 0 0 1-.875-.875Z" }),
        React.createElement("path", { d: "M6.079 3.337c-1.266-.952-3.075-.05-3.077 1.534l-.012 11.17c-.003 1.847 2.348 2.634 3.458 1.157L9.1 13.671a.422.422 0 0 1 .337-.169l4.414.005c1.846.003 2.633-2.348 1.156-3.458L6.08 3.337Z" }),
        React.createElement("path", { d: "M13.9 5.248a.875.875 0 1 0 0 1.75h3.35a.875.875 0 0 0 0-1.75H13.9Z" })));
});
